module.exports = __webpack_public_path__ + "static/media/apple.41287880.png";